import ContractsResource from "./contracts.resource";

const contractsModule = angular
  .module("app.resources.contracts", [])
  .service("Contracts", ContractsResource);

export default contractsModule;



// WEBPACK FOOTER //
// ./src/resources/contracts/contracts.module.js